export default __webpack_public_path__ + "static/media/M47.8905efa6.svg";